let queryParams = {};

try {
  location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (s, k, v) {
    queryParams[k] = v
  });
} catch (e) {
  console.error('Failed to parse queryParams');
}

module.exports = queryParams;
